import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import {
  PopoverBody,
  UncontrolledPopover,
} from 'reactstrap';

import { getCollection } from '../../../actions/Collections';

import CollectionsDate from '../../../components/Collections/Date';
import CollectionDescriptionIcon from '../../../components/Collections/DescriptionIcon';

import {
  isArchive,
  isEllipsisActive,
} from '../../../helpers/App';
import { thumbnailPlaceholder } from '../../../helpers/Collections';

class CollectionsMiniGridItem extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      mounted: false,
    };

    this.elRef = React.createRef();
  }

  componentDidMount() {
    this.setState({ mounted: true });
  }

  getCollectionUrl() {
    const { collection } = this.props;

    let url = `/collections/${collection.uuid}`;
    if (isArchive()) {
      url = `/archive${url}`;
    }

    return url;
  }

  handleCollectionClick(collection) {
    const { getCollectionAction } = this.props;
    getCollectionAction(collection);
  }

  render() {
    const { mounted } = this.state;
    const {
      collection,
    } = this.props;
    const featuredFile = collection.featured_file;
    const subCollections = collection.child_collections_count || 0;

    return (
      <div
        id={collection.uuid}
        className={classnames(
          'collections-item',
          'col-sm-12',
        )}
      >
        <div>
          <Link
            to={this.getCollectionUrl()}
            className="collections-item-img-wrapper"
            onClick={() => { this.handleCollectionClick(collection); }}
          >
            {featuredFile ? (
              <img
                className="collections-item-img"
                width="100%"
                src={featuredFile.urls.thumbnail}
                srcSet={`${featuredFile.urls.thumbnail} 1x, ${featuredFile.urls.thumbnailx2} 2x`}
                alt={collection.name}
              />
            ) : (
              <img
                className="collections-item-img"
                width="100%"
                src={thumbnailPlaceholder}
                alt={collection.name}
              />
            )}
            {(collection.files_count > 0 || subCollections > 0) && (
              <div className="collection-files-count">
                {subCollections > 0 && (
                  <span>
                    <i className="far fa-layer-group" />{' '}
                    {subCollections}
                  </span>
                )}
                {collection.files_count > 0 && (
                  <span>
                    <i className="far fa-file" />{' '}
                    {collection.files_count}
                  </span>
                )}
              </div>
            )}
          </Link>
          <div className="collections-item-body">
            <h5 className="collections-item-title" id={`collection-title-${collection.uuid}`}>
              <Link
                to={this.getCollectionUrl()}
                title={collection.name}
                onClick={() => { this.handleCollectionClick(collection); }}
                ref={this.elRef}
              >
                {collection.name}
              </Link>
            </h5>
            {(mounted && isEllipsisActive(this.elRef.current)) && (
              <UncontrolledPopover
                className="file-popover"
                trigger="hover"
                fade={false}
                placement="top"
                positionFixed={true}
                target={`collection-title-${collection.uuid}`}
              >
                <PopoverBody>
                  <h5 className="masonry-item-title">
                    <Link
                      to={this.getCollectionUrl()}
                      title={collection.name}
                      onClick={() => { this.handleCollectionClick(collection); }}
                    >
                      {collection.name}
                    </Link>
                  </h5>
                </PopoverBody>
              </UncontrolledPopover>
            )}
            <div className="collections-item-details collection-details">
              <div>
                <CollectionsDate collection={collection} />
              </div>
              <div>
                <CollectionDescriptionIcon
                  collection={collection}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getCollectionAction: (collection) => {
    dispatch(getCollection(collection));
  },
});

CollectionsMiniGridItem.propTypes = {
  getCollectionAction: PropTypes.func.isRequired,
  collection: PropTypes.object.isRequired,
};

export default connect(null, mapDispatchToProps)(CollectionsMiniGridItem);
